var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nav',{class:{'menu':true, 'dark': _vm.isDark(), 'light':!_vm.isDark()}},[_c('div',{class:{'menu-item':true}},[_c('router-link',{attrs:{"to":"/CV"}},[_vm._v("CV")])],1),_c('div',{class:{'menu-item':true}},[_c('router-link',{attrs:{"to":"/projects"}},[_vm._v("Projects")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }